export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/~/d3-shape/src/array.js
// module id = ../../../../d3-shape/src/array.js
// module chunks = 3